import { render } from "./FollowUpDue.vue?vue&type=template&id=14b2cc81&scoped=true&lang=pug"
import script from "./FollowUpDue.vue?vue&type=script&lang=js"
export * from "./FollowUpDue.vue?vue&type=script&lang=js"

import "./FollowUpDue.vue?vue&type=style&index=0&id=14b2cc81&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b2cc81"]])

export default __exports__